export function headerHeight() {
  const header = document.querySelector("header");
  const content = document.querySelector("main");
  const kv = document.querySelector(".kv");

  if (header && content) {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === header) {
          const headerHeight = header.offsetHeight;
          content.style.marginTop = headerHeight + "px";
          kv.style.setProperty("--hh", headerHeight + "px");
        }
      }
    });

    resizeObserver.observe(header);
  }
}
